// extracted by mini-css-extract-plugin
export default {"top-title-box":"HealthWriteList_top-title-box__tc1gu","emotion-write-box":"HealthWriteList_emotion-write-box__Z0brI"};